define('app/config/aggregateOptions',{
	MEASURE: [{
		value: 'SUM',
		label: 'Sum'
	}, {
		value: 'AVG',
		label: 'Average'
	}, {
		value: 'MEDIAN',
		label: 'Median'
	}, {
		value: 'MIN',
		label: 'Min'
	}, {
		value: 'MAX',
		label: 'Max'
	}, {
		value: 'STDDEV',
		label: 'Std. Dev.'
	}, {
		value: 'COUNT',
		label: 'Count'
	}, {
		value: 'COUNTD',
		label: 'Count Distinct'
	}],
	DIMENSION: [{
		value: 'COUNTD',
		label: 'Count Distinct'
	}, {
		value: 'COUNT',
		label: 'Count'
	}]
});

